<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { getSettingsPageTitleIcon } from 'dashboard/helper/settingsRouteIcons';

const props = defineProps({
  headerTitle: { type: String, default: '' },
  headerContent: { type: String, default: '' },
  titleIcon: {
    type: String,
    default: '',
  },
});

const route = useRoute();

const resolvedTitleIcon = computed(() => {
  if (typeof props.titleIcon === 'string' && props.titleIcon.trim()) {
    return props.titleIcon.trim();
  }
  return getSettingsPageTitleIcon(route.name);
});
</script>

<template>
  <div class="mb-4 flex w-full flex-col items-start gap-1.5">
    <div class="flex w-full gap-3">
      <div
        v-if="resolvedTitleIcon"
        class="flex size-10 shrink-0 items-center justify-center rounded-xl outline outline-1 outline-n-weak -outline-offset-1"
      >
        <Icon :icon="resolvedTitleIcon" class="size-5 text-n-slate-12" />
      </div>
      <div class="flex min-w-0 flex-1 flex-col gap-1.5">
        <h2 class="mb-0 break-words text-heading-1 text-n-slate-12">
          {{ headerTitle }}
        </h2>
        <p
          v-dompurify-html="headerContent"
          class="w-full text-body-main text-n-slate-11"
        />
      </div>
    </div>
  </div>
</template>
